export interface FeatureFlag {
    key: string;
    name: string;
    description: string;
    defaultValue: boolean;
    currentValue?: boolean;
    isNonProdOnly?: boolean;
}

export type FeatureFlagCollection = {
    RollHtaContracts: FeatureFlag;
    HideEnvironmentWarningBanner: FeatureFlag;
    ShowTranslations: FeatureFlag;
    UseNewAddOfferModal: FeatureFlag;
    
    /* Non-prod only */
    ShowProdHeader: FeatureFlag;
    IgnoreBidEditorBlackout: FeatureFlag;
    ShowAccountsForMerchantsWithoutErp: FeatureFlag;
    AllowContractPricingForCustomers: FeatureFlag;
}

const featureFlags: FeatureFlagCollection = {
    RollHtaContracts: buildFlag("RollHtaContracts", false, "Roll HTA Contracts", "Allow users to roll HTA contracts (AUT-2813)"),
    HideEnvironmentWarningBanner: buildFlag("HideEnvironmentWarningBanner", false, "Hide Environment Warning Banner", "Hide warning banner for the current environment"),
    ShowTranslations: buildFlag("ShowTranslations", false, "Show Translations", "Allow users to choose a language from the profile menu and the text on screen will be translated to the chosen language"),
    UseNewAddOfferModal: buildFlag("UseNewAddOfferModal", false, "Use New Add Offer Modal", "Use the new add offer modal"),
 
   /* Non-prod only flags */
    ShowProdHeader: buildNonProdOnlyFlag("ShowProdHeader", false, "Show Prod Header", "Show production header for marketing screenshot purposes (remove environment name)"),
    IgnoreBidEditorBlackout: buildNonProdOnlyFlag("IgnoreBidEditorBlackout", false, "Ignore Bid Editor Blackout Period", "Ignore the blackout period for Bid Editor"),
    ShowAccountsForMerchantsWithoutErp: buildNonProdOnlyFlag("ShowAccountsForMerchantsWithoutErp", false, "Always Show Customer Accounts", "Always show customer accounts page, even if the merchant doesn't have ERP integration"),
    AllowContractPricingForCustomers: buildNonProdOnlyFlag("AllowContractPricingForCustomers", false, "Allow Contract Pricing For Customers", "Make Set Futures and Set Basis available for Customers")
};

function buildFlag(key: string, defaultValue: boolean, name: string, description: string): FeatureFlag {
    return { key, name, description, defaultValue, currentValue: defaultValue };
}

function buildNonProdOnlyFlag(key: string, defaultValue: boolean, name: string, description: string): FeatureFlag {
    return { key, name, description, defaultValue, currentValue: defaultValue, isNonProdOnly: true };
}

export default featureFlags;